@if (label()) {
    <form-label
        [id]="name() + '-label'"
        [forId]="name() + '-radio-options'"
        [label]="label() | translate"
        [required]="required()"
        [tooltipText]="tooltipText()"
        [hasError]="invalid()">
    </form-label>
}

<div [id]="name() + '-radio-options'" [class.inline]="inline()" class="radio-buttons">
    @for (option of options(); track option.id) {
        <div class="radio-option">
            <p-radioButton
                [inputId]="option.id"
                [name]="name()"
                [disabled]="disabled() || option.disabled || false"
                [value]="option.value"
                [(ngModel)]="model"></p-radioButton>
            <label [for]="option.id" [class.form-label]="true" [innerHTML]="option.label | translate"></label>
        </div>
    }
</div>
